var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6726 5.71867C10.6726 5.41466 10.9191 5.16821 11.2231 5.16821H14.8928C15.1968 5.16821 15.4432 5.41466 15.4432 5.71867C15.4432 6.02268 15.1968 6.26913 14.8928 6.26913H11.2231C10.9191 6.26913 10.6726 6.02268 10.6726 5.71867Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6726 7.55351C10.6726 7.2495 10.9191 7.00305 11.2231 7.00305H13.0579C13.3619 7.00305 13.6084 7.2495 13.6084 7.55351C13.6084 7.85752 13.3619 8.10397 13.0579 8.10397H11.2231C10.9191 8.10397 10.6726 7.85752 10.6726 7.55351Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.69411 4.43429C6.78711 4.43429 4.43417 6.78723 4.43417 9.69423C4.43417 12.6012 6.78711 14.9542 9.69411 14.9542C12.6011 14.9542 14.954 12.6012 14.954 9.69423C14.954 9.39022 15.2005 9.14377 15.5045 9.14377C15.8085 9.14377 16.055 9.39022 16.055 9.69423C16.055 13.2092 13.2091 16.0551 9.69411 16.0551C6.17909 16.0551 3.33325 13.2092 3.33325 9.69423C3.33325 6.17921 6.17909 3.33337 9.69411 3.33337C9.99812 3.33337 10.2446 3.57982 10.2446 3.88383C10.2446 4.18784 9.99812 4.43429 9.69411 4.43429Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5038 14.5038C14.7187 14.2888 15.0673 14.2888 15.2822 14.5038L16.5055 15.727C16.7204 15.942 16.7204 16.2905 16.5055 16.5055C16.2905 16.7204 15.942 16.7204 15.727 16.5055L14.5038 15.2822C14.2888 15.0673 14.2888 14.7187 14.5038 14.5038Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d6246bac.svg";
export { ForwardRef as ReactComponent };